import { http } from '@/lib/apiClient';

export interface PermissionDto { id: string; code: string; name: string; module: string }
export interface RoleSummary { id: string; code: string; name: string; description: string; isSystem: boolean; userCount: number }
export interface RoleDetail extends RoleSummary { createdAt: string; permissions: PermissionDto[] }

export const rolesApi = {
  list: () => http.get<RoleSummary[]>('/api/v1/roles'),
  getById: (id: string) => http.get<RoleDetail>(`/api/v1/roles/${id}`),
  create: (body: { code: string; name: string; description: string }) => http.post<RoleDetail>('/api/v1/roles', body),
  update: (id: string, body: { name: string; description: string }) => http.put<RoleDetail>(`/api/v1/roles/${id}`, body),
  setPermissions: (id: string, permissionIds: string[]) => http.put<RoleDetail>(`/api/v1/roles/${id}/permissions`, { permissionIds }),
  delete: (id: string) => http.delete<void>(`/api/v1/roles/${id}`),
  permissions: () => http.get<PermissionDto[]>('/api/v1/permissions'),
};
